import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { UsersRound } from "lucide-react";
import { toast } from "sonner";

export default function Parents() {
  const [parents, setParents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/parents")
      .then((res) => setParents(res.data))
      .catch(() => toast.error("Could not load parents"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Skeleton className="h-64 rounded-[var(--radius)]" />;

  if (parents.length === 0) {
    return (
      <div className="rounded-[var(--radius)] border bg-card p-12 text-center space-y-2" data-testid="parents-empty-state">
        <UsersRound className="h-8 w-8 mx-auto text-muted-foreground" />
        <p className="text-sm text-muted-foreground">No parent accounts registered yet.</p>
      </div>
    );
  }

  return (
    <div className="rounded-[var(--radius)] border bg-card p-2" data-testid="parents-page">
      <Accordion type="multiple">
        {parents.map((p) => (
          <AccordionItem key={p.id} value={p.id} className="px-3">
            <AccordionTrigger data-testid="parent-accordion-trigger">
              <div className="flex flex-col items-start text-left">
                <span className="font-medium">{p.full_name}</span>
                <span className="text-xs text-muted-foreground">{p.email} {p.phone && `· ${p.phone}`}</span>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              {(!p.students || p.students.length === 0) ? (
                <p className="text-sm text-muted-foreground pb-2">No students registered.</p>
              ) : (
                <ul className="space-y-1 pb-2">
                  {p.students.map((s) => (
                    <li key={s.id} className="text-sm flex items-center justify-between" data-testid="parent-student-item">
                      <span>{s.full_name}</span>
                      <span className="text-xs text-muted-foreground capitalize">{s.status}</span>
                    </li>
                  ))}
                </ul>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
